import { BorderColor, TagColor } from '../interface/common';

export enum TasksFilterValues {
  allTasks = 'all',
  completed = 'completed',
  inComplete = 'incomplete',
}
export enum TasksPriority {
  high = 'high',
  normal = 'normal',
  low = 'low',
}
export enum TaskSections {
  criticalTasks = 'critical',
  generalTasks = 'general',
}
export enum TaskDetailSections {
  general = 'general',
  worktimes = 'worktimes',
  notes = 'notes',
}
export const GENERAL_ENTITY_DISABLED_ID = 'E4B9F409-1917-48DB-B39E-933DA94A8593';
export const GENERAL_ENTITY_ENABLED_ID = '118A7D24-A558-4CC8-8E75-7B5D9723696D';

export const TASK_STATUS_DEFERRED_ID = '428216E8-00F4-475C-AB67-F73539912E9D';
export const TASK_STATUS_WAITING_ON_SOMEONE_ELSE_ID = '2E5C7CEE-F2C9-4DF2-B2C5-4964698C6FF9';
export const TASK_STATUS_IN_PROGRESS_ID = '6D3B7788-1AC0-4EC6-85F1-57C792496C5C';

export const taskFields = [
  'subject',
  'startTime',
  'dueTime',
  'alertTime',
  'priority',
  'matterId',
  'statusId',
  'description',
  'hasImportantNotes',
  'hasNotes',
  'responsibleUserId',
  'duration',
  'transactionId',
];
export const taskRelations = [
  'matter.parties',
  'matter.parties.company',
  'matter.parties.privatePerson',
  'matter:subject,matterNumber,currency,invoiceableType',
  'responsibleUser:fullName',
  'status',
  'transaction',
  'activityType',
  'workTimes:duration',
];
export const tagColorMapping: { [key: string]: TagColor } = {
  [GENERAL_ENTITY_ENABLED_ID]: TagColor.RED,
  [GENERAL_ENTITY_DISABLED_ID]: TagColor.DARKGREY,
  [TASK_STATUS_DEFERRED_ID]: TagColor.LIGHTBLUE,
  [TASK_STATUS_WAITING_ON_SOMEONE_ELSE_ID]: TagColor.RED,
  [TASK_STATUS_IN_PROGRESS_ID]: TagColor.YELLOW,
  default: TagColor.YELLOW,
};

export const cardBorderColorMapping: { [key: string]: BorderColor } = {
  [GENERAL_ENTITY_ENABLED_ID]: BorderColor.RED,
  [GENERAL_ENTITY_DISABLED_ID]: BorderColor.DARKGREY,
  [TASK_STATUS_DEFERRED_ID]: BorderColor.LIGHTBLUE,
  [TASK_STATUS_WAITING_ON_SOMEONE_ELSE_ID]: BorderColor.RED,
  [TASK_STATUS_IN_PROGRESS_ID]: BorderColor.YELLOW,
  default: BorderColor.YELLOW,
};

export const TASK_QUERY_KEYS_TO_INVALIDATE = ['tasks-list', 'task-details'];
